export default {"src":"/_next/static/media/arrow-left-outline.0edb4662.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};